<template>
  <Suspense>
    <template #default>
      <PublicationsList :url="url" :collectionId="groupId" :style="style" />
    </template>
    <template #fallback>
      <Loader />
    </template>
  </Suspense>
</template>
<script>
import { defineAsyncComponent } from "vue";
import Loader from "@/components/common/Loader";

export default {
  components: {
    Loader,
    PublicationsList: defineAsyncComponent(() =>
      import("../../components/publications/PublicationsList")
    )
  },
  props: {
    groupType: {
      type: String,
      default: () => "collection",
      validator(value) {
        return ["collection", "community"].includes(value);
      }
    },
    groupId: {
      type: Number,
      required: true
    },
    style: {
      type: String,
      default: "default",
      validator(value) {
        return ["APA", "default"].includes(value);
      }
    }
  },
  setup() {
    const url = process.env.VUE_APP_REGEN_API;
    return {
      url
    };
  }
};
</script>
